/**
 * Store form information in DataLayer.
 *
 * @export
 * @param {string} formName
 * @param {"submit"|"start"|"error"|"input"|"page_submit"} event
 * @param {{field_name: string, field_value: string} | {form_page: string, form_step_number: number} | { form_page: string, error_message: string}} [data]
 */
export function formEvent(formName, event, data) {
  const payload = Object.assign(
    {},
    {
      form_name: formName,
    },
    data
  );

  window.dataLayer.push({ form: null });
  window.dataLayer.push({
    event: `form_${event}`,
    form: payload,
  });

  // Segment
  window?.analytics?.track(`form_${event}`, payload);
}

/**
 * Store customer information in DataLayer.
 *
 * @export
 * @param {string} name - Full name
 * @param {string} email - Email
 * @param {string} subscriptionId - Stripe customer id
 */
export function kycEvent(name, email, subscriptionId) {
  window.dataLayer.push({ kyc: null });
  window.dataLayer.push({
    kyc: {
      name,
      email,
      id: subscriptionId,
    },
  });
}

/**
 * Serialize tier as DataLayer item
 *
 * @param {tier[]|tier} tiers - Tier or Array of Tiers
 * @param {string} couponCode - Any coupon code applied to the item
 * @param {string} currency - 'USD' or 'USDC'
 * @return {Array<{item_id,item_name,index,currency,price,quantity,coupon,discount}>}
 */
function tiersToItems(tiers, couponCode, currency) {
  return (Array.isArray(tiers) ? tiers : [tiers]).map((t, index) => ({
    item_id: t.tierId,
    item_name: t.tierName,
    index,
    currency: currency,
    price: t.price / 100, // Convert Stripe price
    quantity: 1,
    coupon: couponCode,
  }));
}

/**
 * Store purchase information in DataLayer
 *
 * @export
 * @param {tier} tier - Selected tier
 * @param {string} couponCode - Any coupon code applied to the tier
 * @param {string} currency - Currency (USD or USDC)
 * @param {string} transactionId - Id of stripe transaction
 */
export function purchaseEvent(tier, couponCode, currency, transactionId) {
  const payload = {
    currency: currency,
    value: (tier?.couponPrice || tier?.price || 0) / 100 || 0,
    coupon: couponCode,
    transaction_id: transactionId,
    items: tiersToItems(tier, couponCode, currency),
  };

  // GTM
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: payload,
  });
  // Segment
  window?.analytics?.track('purchase', payload);
}
